import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext, useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import Button from '../../../../components/Button';
import DefaultCard from '../../../../components/DefaultCard';
import IconButton from '../../../../components/IconButton';
import Link from '../../../../components/Link';
import ModalHeader from '../../../../components/ModalHeader';
import { RadioGroup } from '../../../../components/Radio';
import SelectableCard from '../../../../components/SelectableCard';
import { EnrollmentStore } from '../../../../providers/enrollment';
import { getAllSpouseLifeInsurances } from '../../../../services/enrollment';

export type customSpouseLifeInsuranceModalProps = {
  showSpouseLifeInsuranceModal: boolean;
  handleCloseSpouseLifeInsuranceModal: () => void;
};

const SpouseLifeInsuranceModal = ({
  showSpouseLifeInsuranceModal,
  handleCloseSpouseLifeInsuranceModal,
}: customSpouseLifeInsuranceModalProps) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [spouseLifeInsuranceData, setSpouseLifeInsuranceData] =
    React.useState<any>({});

  const [radioButtonValue, setRadioButtonValue] = React.useState<
    string | number
  >(0);
  const [tellMeMore, setTellMeMore] = useState(false);
  const { activeLifeAndDisabilityInsurances, updateCost, updatePlanName } =
    useContext(EnrollmentStore);

  useEffect(() => {
    const data = getAllSpouseLifeInsurances();

    if (data) {
      setSpouseLifeInsuranceData(data);
    }
  }, [spouseLifeInsuranceData]);

  useEffect(() => {
    const currentBenefit = activeLifeAndDisabilityInsurances.find(
      (benefit: any) => benefit.type === 'spouse-life'
    );
    const index = spouseLifeInsuranceData.plans?.findIndex(
      (plan: any) => plan.id === currentBenefit?.plan?.id
    );
    setRadioButtonValue(index);
  }, [activeLifeAndDisabilityInsurances, spouseLifeInsuranceData]);

  const handleRadioButtonValue = (e: string | number) => {
    setRadioButtonValue(e);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleTellMeMore = () => {
    setTellMeMore((prev) => !prev);
  };

  return (
    <>
      {spouseLifeInsuranceData ? (
        <Modal
          show={showSpouseLifeInsuranceModal}
          onHide={handleCloseSpouseLifeInsuranceModal}
          dialogClassName="modal-xl"
          className="custom-health-savings-modal"
        >
          <ModalHeader
            rightButton={
              <div onClick={toggleDetails} className={'icon-button-wrapper'}>
                <IconButton
                  variant="icon-default"
                  icon={light('circle-exclamation')}
                  extLabel="Benefit Info"
                />
              </div>
            }
            leftIcon={light('hospitals')}
            leftIconVariant="icon-default"
          >
            <h4 className="text-sm-20-lg-32">
              {spouseLifeInsuranceData['generic']
                ? spouseLifeInsuranceData['generic']['title']
                : ''}
            </h4>
          </ModalHeader>
          <ModalBody>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="d-flex justify-content-center">
                <DefaultCard
                  closeButton={
                    <Link 
                      className='pt-0' 
                      isAlignAtEnd 
                      isWhiteIcon 
                      rightIcon={light('close')}
                      onClick={toggleDetails}
                    />                      
                  }
                  variant="blue-motif"
                  leftHeading={
                    spouseLifeInsuranceData['generic']
                      ? spouseLifeInsuranceData['generic']['info']['title']
                      : ''
                  }
                  leftSubheading={
                    <Container className={'px-0 d-flex flex-column'}>
                      {spouseLifeInsuranceData['generic'] ? (
                        <>
                          <span>
                            {
                              spouseLifeInsuranceData['generic']['info'][
                                'description'
                              ]
                            }
                          </span>
                          {tellMeMore && (
                            <span className={'mt-1'}>
                              {
                                spouseLifeInsuranceData['generic']['info'][
                                  'additionalDescription'
                                ]
                              }
                            </span>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </Container>
                  }
                  button={
                    <Button
                      onClick={handleTellMeMore}
                      variant="primary-shadow"
                      size="sm"
                    >
                      {tellMeMore ? 'Tell me less' : 'Tell me more'}
                    </Button>
                  }
                  className={'mb-12'}
                />
              </div>
            </Row>
            <Container className="p-0">
              <Row className="mb-7 mb-lg-12">
                <h5 className="text-sm-14-lg-24">What option would you like?</h5>
              </Row>
              <Row>
                <RadioGroup
                  name={'pricing-test1'}
                  value={radioButtonValue}
                  onChange={handleRadioButtonValue}
                >
                  <div>
                    {spouseLifeInsuranceData['plans']
                      ? spouseLifeInsuranceData['plans'].map(
                          (
                            plan: {
                              title: string;
                              cost: any;
                              coverage: number;
                              subtitle1: string;
                            },
                            i: any
                          ) => (
                            <SelectableCard
                              title={plan.title}
                              subtitle1={plan.subtitle1 ? plan.subtitle1 : ''}
                              subtitle1WarningColor={
                                plan.subtitle1 ? true : false
                              }
                              prePaydPeriod={plan.cost}
                              radioButtonValue={i}
                              selected={radioButtonValue === i}
                              disabled={
                                i ===
                                spouseLifeInsuranceData['plans'].length - 1
                              }
                              key={i}
                            />
                          )
                        )
                      : ''}
                  </div>
                </RadioGroup>
              </Row>
            </Container>
          </ModalBody>
          <Modal.Footer className="pt-7">
            <Button
              onMouseDown={handleCloseSpouseLifeInsuranceModal}
              className="text-nowrap mt-7 mt-lg-0"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={() => {
                updateCost(
                  'spouse-life',
                  spouseLifeInsuranceData.plans[radioButtonValue]
                );
                updatePlanName(
                  'spouse-life',
                  spouseLifeInsuranceData.plans[radioButtonValue]
                );
                handleCloseSpouseLifeInsuranceModal();
              }}
              className="text-nowrap"
              variant="primary"
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        'NO DATA'
      )}
    </>
  );
};

export default SpouseLifeInsuranceModal;
